import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel";
import Link from "@mui/material/Link";
import FormHelperText from "@mui/material/FormHelperText"
import InputLabel from "@mui/material/InputLabel"
import Select from "@mui/material/Select"
import Stack from "@mui/material/Stack"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Switch from "@mui/material/Switch"
import Checkbox from "@mui/material/Checkbox";
import MenuItem from "@mui/material/MenuItem"
import { Controller } from "react-hook-form"

const switchStyle = {
  textTransform: 'uppercase',
  color: 'grey.500',
  fontSize: '0.9rem',
  fontWeight: 600,
  paddingTop: '3px',
}
  
export const FormSelect = ({
  name,
  label,
  control,
  defaultValue,
  children,
  options,
  helperText,
  ...props
}) => {
  const labelId = `${name}-label`
  return (
    <FormControl {...props}>
      <InputLabel htmlFor={label}>{label}</InputLabel>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <Select
            value={value}
            onChange={onChange}
            label={label}
            labelId={labelId}
            MenuProps={{ PaperProps: { sx: { maxHeight: '70vh' } } }}
          >
            {options.map((o) => {
              return <MenuItem key={o.value} value={o.value}>{o.name}</MenuItem>
            })}
          </Select>
        )}
        defaultValue={defaultValue || ''}
      />
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  )
}

export const FormSwitch = ({
  name,
  label,
  control,
  defaultValue,
  children,
  helperText,
  ...props
}) => {
  //console.log('[FormSwitch]', control, defaultValue)
  return (
    <FormControl {...props}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        mx: 1.5,
        my: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography component='span'>{label}</Typography>
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, value } }) => {
            //console.log('[Switch.render]', value)
            return (
              <Stack direction="row" spacing={0} alignItems="center" sx={{ paddingRight: 2 }}>
                <Typography component='span' sx={ switchStyle }>Off</Typography>
                <Switch
                  name='emailNotifications'
                  checked={value}
                  value={value}
                  onChange={(e, val) => {
                    return onChange(val)
                  }}
                />
                <Typography component='span' sx={ switchStyle }>On</Typography>
              </Stack>
            )
          }}
        />
      </Box>
      <FormHelperText sx={{ marginLeft: 0 }}>{helperText}</FormHelperText>
    </FormControl>
  )
}
      //<InputLabel htmlFor={label}>{label}</InputLabel>

export const FormCheckbox = ({
  name,
  control,
  defaultValue,
  label,
  helperText,
  ...props
}) => {
  return (
    <FormControl {...props}>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue || false}
        render={({ field: { onChange, value } }) => (
          <FormControlLabel
            control={
              <Checkbox
                checked={value}
                onChange={e => onChange(e.target.checked)}
              />
            }
            label={
              <Typography>
                {label.map((part, index) =>
                  typeof part === 'string' ?
                  part :
                  <Link key={index} href={part.href} target="_blank" rel="noopener">{part.text}</Link>
                )}
              </Typography>
            }
          />
        )}
      />
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  )
}
